// Runtime config desteği: window.__APP_CONFIG__ build sonrası güncellenebilir
const getApiBaseUrl = () => {
  // Önce runtime config'i kontrol et (build sonrası güncellenebilir)
  if (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__.API_BASE_URL) {
    return window.__APP_CONFIG__.API_BASE_URL;
  }
  // Sonra environment variable'ları kontrol et
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Varsayılan: mevcut origin + /api (aynı domain altında)
  if (typeof window !== 'undefined') {
    return window.location.origin + '/api';
  }
  // Fallback (backend varsayılan port - launchSettings: 5278)
  return 'http://localhost:5278/api';
};

export const API_BASE_URL = getApiBaseUrl();

export const DAVA_TURU = {
  None: 0,
  TrafikKazasi: 1,
  Ceza: 2,
  GeciciIsGormezlik: 3,
  Sorusturma: 4,
  MaddiHasar: 5,
  DegerKaybi: 6,
  MaddiHasarDegerKaybi: 7,
  KazancKaybi: 8,
  Kasko: 9,
  MaddiHasarImms: 10,
  DegerKaybiImms: 11,
  DestekYoksunKalma: 12,
  TrafikKazasiMaluliyet: 13,
  TrafikKazasiVefat: 14,
  MaddiTazminat: 15,
  ManeviTazminat: 16,
  IseIade: 17,
  IscilikAlacaklari: 18,
  IsKazasiVefat: 19,
  IsKazasiMaluliyet: 20,
  TrafikIsKazasiMaluliyet: 21,
  TrafikIsKazasiVefat: 22,
  IcraDava: 23,
  IcraTaki: 24,
  Kamulastirma: 25,
  IdariDava: 26,
  IdariDavaVefat: 27,
  IdariDavaYaralanma: 28,
  ElektrikCarpmasi: 29,
  Tuketici: 30,
  Bosanma: 31,
  Rucu: 32,
  DelilTespit: 33,
  MenfiTespit: 34,
  MaluliyetTespit: 35,
  IzaleyiSuyu: 36,
  MalRejimininTasfiyesi: 37,
  Protez: 38,
  Malpraktis: 39,
  ItirazinIptali: 40,
  VasiTayini: 41,
  Tahliye: 42,
  HaksizAzil: 43,
  TerekeTespit: 44,
  MirasDavasi: 45,
  MaddiManeviTazminat: 46,
  SulhCezaItiraz: 47,
  AracMahrumiyetBedeli: 48,
  MaddiHasarDegerKaybiAracMahrumiyet: 49,
  Davali: 50,
  AracMahrumiyetBedeliIcraTakip: 51,
  SavcilikSikayet: 52,
  SavcilikSorusturma: 53,
  MirascilikBelgesi: 54,
  VerasetIlami: 55,
  TrafikCezasiItiraz: 57,
  HayatSigortasi: 58,
  TapuIptalVeTescil: 59,
  // "Diger" secildiginde tur adi elle yazilir; CaseFile.DavaTuruDiger alaninda saklanir.
  Diger: 56
};

export const DAVA_TURU_LABELS = {
  0: 'Seçiniz',
  1: 'Trafik Kazası',
  2: 'CEZA',
  3: 'GEÇİCİ İŞ GÖREMEZLİK',
  4: 'SORUŞTURMA',
  5: 'MADDİ HASAR',
  6: 'DEĞER KAYBI',
  7: 'MADDİ HASAR - DEĞER KAYBI',
  8: 'KAZANÇ KAYBI',
  9: 'KASKO',
  10: 'MADDİ HASAR - İMMS',
  11: 'DEĞER KAYBI - İMMS',
  12: 'DESTEK YOKSUN KALMA',
  13: 'TRAFİK KAZASI MALULİYET',
  14: 'TRAFİK KAZASI VEFAT',
  15: 'MADDİ TAZMİNAT',
  16: 'MANEVİ TAZMİNAT',
  17: 'İŞE İADE',
  18: 'İŞÇİLİK ALACAKLARI',
  19: 'İŞ KAZASI VEFAT',
  20: 'İŞ KAZASI MALULİYET',
  21: 'TRAFİK İŞ KAZASI MALULİYET',
  22: 'TRAFİK İŞ KAZASI VEFAT',
  23: 'İCRA DAVA',
  24: 'İCRA TAKİP',
  25: 'KAMULAŞTIRMA',
  26: 'İDARİ DAVA',
  27: 'İDARİ DAVA - VEFAT',
  28: 'İDARİ DAVA - YARALANMA',
  29: 'ELEKTRİK ÇARPMASI',
  30: 'TÜKETİCİ',
  31: 'BOŞANMA',
  32: 'RUCÜ',
  33: 'DELİL TESPİT',
  34: 'MENFİ TESPİT',
  35: 'MALULİYET TESPİT',
  36: 'İZALEYİ ŞUYU',
  37: 'MAL REJİMİ (BOŞANMA)',
  38: 'PROTEZ',
  39: 'MALPRAKTİS',
  40: 'İTİRAZIN İPTALİ',
  41: 'VASİ TAYİNİ',
  42: 'TAHLİYE',
  43: 'HAKSIZ AZİL',
  44: 'TEREKE TESPİT',
  45: 'MİRAS DAVASI',
  46: 'MADDİ MANEVİ TAZMİNAT',
  47: 'SULH CEZA İTİRAZ',
  48: 'ARAÇ MAHRUMİYET BEDELİ (DAVA)',
  49: 'MADDİ HASAR - DEĞER KAYBI - ARAÇ MAHRUMİYET',
  50: 'DAVALI',
  51: 'ARAÇ MAHRUMİYET BEDELİ (İCRA TAKİP)',
  52: 'SAVCILIK ŞİKAYET',
  53: 'SAVCILIK SORUŞTURMA',
  54: 'MİRASÇILIK BELGESİ',
  55: 'VERASET İLAMI',
  57: 'TRAFİK CEZASI İTİRAZ',
  58: 'HAYAT SİGORTASI',
  59: 'TAPU İPTAL VE TESCİL',
  56: 'DİĞER'
};

// İcra Takip dava türü seçildiğinde dosya detayındaki "İcra konusu" seçenekleri
export const ICRA_KONUSU_OPTIONS = [
  'İlamsız',
  'İlamlı',
  'Araç Mahrumiyet',
  'Senet',
  'Çek',
  'Borç',
  'Kira',
  'Nafaka',
  'İşçilik Alacağı',
  'Tazminat',
  'Kredi / Banka Alacağı',
  'Fatura / Ticari Alacak'
];

// Dava türlerini özel sıralama ile döndürür
// 49 (MADDİ HASAR - DEĞER KAYBI - ARAÇ MAHRUMİYET) -> 7'nin altında
// 48 + 51 (Araç Mahrumiyet dava/icra) -> 49'un altında
// 50 (DAVALI) -> 16'nın altında
// 52, 53 (SAVCILIK ŞİKAYET / SORUŞTURMA) -> 4'ün altında
export const getSortedDavaTuruEntries = () => {
  const entries = Object.entries(DAVA_TURU_LABELS);
  const result = [];
  
  // 0-4 arası (CEZA, SORUŞTURMA)
  for (let i = 0; i <= 4; i++) {
    const entry = entries.find(([value]) => parseInt(value) === i);
    if (entry) result.push(entry);
  }

  // 52, 53 -> SORUŞTURMA'nın hemen altında
  const entry52 = entries.find(([value]) => parseInt(value) === 52);
  if (entry52) result.push(entry52);
  const entry53 = entries.find(([value]) => parseInt(value) === 53);
  if (entry53) result.push(entry53);

  // 5-7 arası
  for (let i = 5; i <= 7; i++) {
    const entry = entries.find(([value]) => parseInt(value) === i);
    if (entry) result.push(entry);
  }
  
  // 49 -> 7'nin hemen altında
  const entry49 = entries.find(([value]) => parseInt(value) === 49);
  if (entry49) result.push(entry49);

  // 48, 51 -> 49'un hemen altında
  const entry48 = entries.find(([value]) => parseInt(value) === 48);
  if (entry48) result.push(entry48);
  const entry51 = entries.find(([value]) => parseInt(value) === 51);
  if (entry51) result.push(entry51);
  
  // 8-16 arası
  for (let i = 8; i <= 16; i++) {
    const entry = entries.find(([value]) => parseInt(value) === i);
    if (entry) result.push(entry);
  }
  
  // 50 -> 16'nın hemen altında
  const entry50 = entries.find(([value]) => parseInt(value) === 50);
  if (entry50) result.push(entry50);
  
  // 17-47 arası (48 ayrı yerleştirildi)
  for (let i = 17; i <= 47; i++) {
    const entry = entries.find(([value]) => parseInt(value) === i);
    if (entry) result.push(entry);
  }
  
  // 54, 55, 57, 58 -> sonradan eklenen turler listenin sonunda
  for (const i of [54, 55, 57, 58]) {
    const entry = entries.find(([value]) => parseInt(value) === i);
    if (entry) result.push(entry);
  }

  // 56 (DİĞER) her zaman en altta: seçilince tür adı elle yazılır
  const entryDiger = entries.find(([value]) => parseInt(value) === 56);
  if (entryDiger) result.push(entryDiger);

  return result;
};

/**
 * Dosyanın dava türü etiketi. "Diğer" seçilmişse elle yazılan metin gösterilir.
 * Hem PascalCase hem camelCase alan adlarını kabul eder (API iki türlü de dönebiliyor).
 */
export const davaTuruEtiketi = (dosya) => {
  if (!dosya) return '';
  const tur = dosya.DavaTuru ?? dosya.davaTuru;
  const serbest = dosya.DavaTuruDiger ?? dosya.davaTuruDiger;
  if (Number(tur) === DAVA_TURU.Diger) {
    return (serbest && String(serbest).trim()) || DAVA_TURU_LABELS[DAVA_TURU.Diger];
  }
  return DAVA_TURU_LABELS[tur] || '';
};

export const CASE_FILE_STATUS = {
  None: 0,
  Bam: 1,
  Bim: 2,
  Yargitay: 3,
  Danistay: 4,
  Azilname: 5,
  Arsiv: 6,
  Basvuru: 7,
  Cekilme: 8,
  KesinKarar: 9,
  Beklemede: 10,
  Arabuluculuk: 11,
  Derdest: 12,
  Karar: 13,
  DavaAcilacak: 14,
  TahkimeGidilecek: 15,
  RaporBekleniyor: 16,
  ArsivKontrol: 17,
  Kesinlesme: 18,
  ItirazHakemHeyeti: 19,
  ItirazHakemHeyetiKarar: 20,
  IcrasiDevamEdiyor: 21,
  // Yeni durumlar (alfabetik sıralı)
  IcraItirazEdildi: 22,
  IcraKesinlestirmeBekleniyor: 23,
  Istinaf: 24,
  SigortaBasvurusuYapildi: 25,
  TahkimBedelArtirimYapildi: 26,
  TahkimBilirkisiRaporuBekleniyor: 27,
  Tahkimde: 28,
  TahkimItirazVeBedelArtirimYapildi: 29,
  TahkimKaraBekleniyor: 30,
  TahkimKarar: 31,
  TahkimRaporaItirazEdildi: 32,
  IcraTakibiBaslatildi: 33
};

// Durum etiketleri - Eski ve yeni sistem uyumluluğu için
export const CASE_FILE_STATUS_LABELS = {
  0: '------',
  1: 'BAM', // Eski sistem: BAM, Yeni sistem: Active (ayırt etmek için getStatusLabel kullanın)
  2: 'BİM', // Eski sistem: BİM, Yeni sistem: ArchiveRequested (ayırt etmek için getStatusLabel kullanın)
  3: 'YARGITAY', // Eski sistem: YARGITAY, Yeni sistem: Archived (ayırt etmek için getStatusLabel kullanın)
  4: 'DANIŞTAY',
  5: 'AZİLNAME',
  6: 'ARŞİV',
  7: 'BAŞVURU',
  8: 'ÇEKİLME',
  9: 'KESİN KARAR',
  10: 'BEKLEMEDE',
  11: 'ARABULUCULUK',
  12: 'DERDEST',
  13: 'KARAR',
  14: 'DAVA AÇILACAK',
  15: 'TAHKİME GİDİLECEK',
  16: 'RAPOR BEKLENİYOR',
  17: 'ARŞİV KONTROL',
  18: 'KESİNLEŞME',
  19: 'İTİRAZ HAKEM HEYETİ',
  20: 'İTİRAZ HAKEM HEYETİ KARAR',
  21: 'İCRASI DEVAM EDİYOR',
  // Yeni durumlar (alfabetik sıralı)
  22: 'İCRA İTİRAZ EDİLDİ',
  23: 'İCRA KESİNLEŞTİRME BEKLENİYOR',
  24: 'İSTİNAF',
  25: 'SİGORTA BAŞVURUSU YAPILDI',
  26: 'TAHKİM BEDEL ARTIRIM YAPILDI',
  27: 'TAHKİM BİLİRKİŞİ RAPORU BEKLENİYOR',
  28: 'TAHKİMDE',
  29: 'TAHKİM İTİRAZ VE BEDEL ARTIRIM YAPILDI',
  30: 'TAHKİM KARA BEKLENİYOR',
  31: 'TAHKİM KARAR',
  32: 'TAHKİM RAPORA İTİRAZ EDİLDİ',
  33: 'İCRA TAKİBİ BAŞLATILDI'
};

// Yeni sistem durum etiketleri (Backend enum değerleri)
export const NEW_CASE_FILE_STATUS_LABELS = {
  1: 'AKTİF', // Active
  2: 'ARŞİV İSTEĞİ', // ArchiveRequested
  3: 'ARŞİV' // Archived
};

// Durum etiketi getirme fonksiyonu - Eski ve yeni sistemi ayırt eder
export const getStatusLabel = (status, caseFile = null) => {
  // Eğer status 1, 2 veya 3 ise ve dosya yeni sistemde ise (ArchiveRequested veya Archived)
  // yeni etiketleri kullan, değilse eski etiketleri kullan
  if (status === 1 || status === 2 || status === 3) {
    // Yeni sistem kontrolü: Eğer dosya arşivlenmişse veya arşiv isteği varsa yeni sistem
    // Backend'den gelen status değeri direkt olarak yeni sistem enum'ından geliyorsa
    // ArchiveRequested (2) veya Archived (3) ise yeni sistem etiketlerini kullan
    if (status === 2) {
      return NEW_CASE_FILE_STATUS_LABELS[2]; // ARŞİV İSTEĞİ
    }
    if (status === 3) {
      return NEW_CASE_FILE_STATUS_LABELS[3]; // ARŞİV
    }
    if (status === 1) {
      // Status 1 için: Eğer dosya arşivlenmiş değilse ve arşiv isteği yoksa "AKTİF"
      // Ama eski sistemde BAM olabilir, bu yüzden caseFile'dan ek bilgi gerekebilir
      // Şimdilik eski sistemi koruyalım, sadece 2 ve 3 için yeni sistemi kullanalım
      return CASE_FILE_STATUS_LABELS[1]; // BAM (eski sistem)
    }
  }
  
  // Diğer durumlar için eski sistem etiketlerini kullan
  return CASE_FILE_STATUS_LABELS[status] || 'Bilinmiyor';
};

export const ARCHIVE_REQUEST_STATUS = {
  Pending: 1,
  Approved: 2,
  Rejected: 3
};

export const ARCHIVE_REQUEST_STATUS_LABELS = {
  1: 'Beklemede',
  2: 'Onaylandı',
  3: 'Reddedildi'
};

export const TASK_STATUS = {
  InProgress: 1,
  UnderReview: 2,
  Completed: 3,
  Rejected: 4
};

export const TASK_STATUS_LABELS = {
  1: 'İşlemde',
  2: 'Kontrol Ediliyor',
  3: 'Tamamlandı',
  4: 'Reddedildi'
};

export const DOCUMENT_TYPE = {
  Other: 0,
  Vekaletname: 1,
  KazaTespitTutanagi: 2,
  Makbuz: 3,
  MatbuDilekce: 4,
  IbranameMuvafakatname: 5,
  // Dosya detayındaki "Masraflar ve Ödemeler" sekmelerinde durur (belge listesinde değil)
  GelenOdemeDekontu: 6,
  MuvekkileOdemeDekontu: 7,
  MasrafBelgesi: 8
};

export const DOCUMENT_TYPE_LABELS = {
  0: 'Diğer',
  1: 'Vekaletname',
  2: 'Kaza Tespit Tutanağı',
  3: 'Makbuz',
  4: 'Matbu Dilekçe',
  5: 'İbraname - Muvafakatname',
  6: 'Gelen Ödeme Dekontu',
  7: 'Müvekkile Ödeme Dekontu',
  8: 'Masraf Belgesi'
};